<div class="modal-header">
  <h4 class="modal-title fw-normal">Manual Post Payment</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="confirm()">
    <div class="mb-3">
      <label for="paymentMethodId" class="form-label"
        >Payment method <span class="text-danger">*</span></label
      >
      <select
        id="paymentMethodId"
        class="form-select"
        formControlName="paymentMethodId"
        [class.is-invalid]="
          form.controls.paymentMethodId.touched && form.controls.paymentMethodId.invalid
        "
      >
        <option value="" disabled>Select a method…</option>
        @for (method of methods(); track method.id) {
        <option [value]="method.id">{{ method.name }}</option>
        }
      </select>
    </div>

    @if (isCheck()) {
    <div class="mb-3">
      <label for="checkNumber" class="form-label"
        >Check number <span class="text-danger">*</span></label
      >
      <input
        id="checkNumber"
        type="text"
        class="form-control"
        formControlName="checkNumber"
        [class.is-invalid]="form.controls.checkNumber.touched && form.controls.checkNumber.invalid"
      />
    </div>
    }

    <div class="mb-3">
      <label for="amount" class="form-label">Amount <span class="text-danger">*</span></label>
      <div class="input-group">
        <span class="input-group-text">$</span>
        <input
          id="amount"
          type="number"
          min="0.01"
          step="0.01"
          class="form-control"
          formControlName="amount"
          [class.is-invalid]="form.controls.amount.touched && form.controls.amount.invalid"
        />
      </div>
    </div>

    <div class="mb-3">
      <label for="paymentDate" class="form-label"
        >Payment date <span class="text-danger">*</span></label
      >
      <input
        id="paymentDate"
        type="date"
        class="form-control"
        formControlName="paymentDate"
        [class.is-invalid]="form.controls.paymentDate.touched && form.controls.paymentDate.invalid"
      />
    </div>

    <div class="mb-2">
      <label for="notes" class="form-label">Notes</label>
      <textarea id="notes" class="form-control" rows="2" formControlName="notes"></textarea>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss('cancel')">
    Cancel
  </button>
  <groundworks-loading-button
    [label]="'Post Payment'"
    [loading]="isSubmitting"
    [disabled]="form.invalid"
    (click)="confirm()"
  />
</div>
